"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames = require("classnames");
var bind_1 = require("../bind");
var overflowing_row_1 = require("./overflowing_row");
var tiles_1 = require("./tiles");
var article_collection_card_1 = require("./article_collection_card");
var ArticleCollectionView = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleCollectionView, _super);
    function ArticleCollectionView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ArticleCollectionView.prototype.renderArticle = function (article) {
        return (React.createElement(article_collection_card_1.default, { article: article, renderForSidebar: this.props.renderForSidebar, key: article && article.id }));
    };
    ArticleCollectionView.prototype.renderForSidebar = function () {
        var classes = classNames('sidebar-articles', { 'sidebar-articles--loading': this.props.loading });
        return (React.createElement("div", { className: classes },
            React.createElement("h4", { className: "sidebar-articles__heading" }, this.props.title),
            React.createElement(tiles_1.default, { oneWide: true, placeholder: this.renderArticle(null), expectedCount: this.props.expectedCount, loading: this.props.loading }, this.props.articles.map(this.renderArticle))));
    };
    ArticleCollectionView.prototype.render = function () {
        if (!this.props.loading && !this.props.articles.length) {
            return null;
        }
        if (this.props.renderForSidebar)
            return this.renderForSidebar();
        return (React.createElement(overflowing_row_1.default, { title: this.props.title, titleHtml: this.props.titleHtml, subtitle: this.props.subtitle, subtitleHtml: this.props.subtitleHtml, ledeHtml: this.props.ledeHtml, collectionCount: this.props.articles.length, action: this.props.action, id: this.props.id },
            React.createElement(tiles_1.default, { threeWide: true, singleRow: true, grow: true, placeholder: this.renderArticle(null), expectedCount: this.props.expectedCount, loading: this.props.loading }, this.props.articles.map(this.renderArticle))));
    };
    ArticleCollectionView.defaultProps = {
        articles: [],
        expectedCount: 3,
    };
    tslib_1.__decorate([
        bind_1.default
    ], ArticleCollectionView.prototype, "renderArticle", null);
    return ArticleCollectionView;
}(React.Component));
exports.default = ArticleCollectionView;
//# sourceMappingURL=article_collection_view.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/article_collection_view.js
// module id = YA9k
// module chunks = 20 21